var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/helpers/testHelpers.js",
  _this = this;
var diff = require('jest-diff');
import React from 'react';
import ThemeProvider from '../core/ThemeProvider';
export var wrapThemeProvider = function wrapThemeProvider(ui) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    theme = _ref.theme;
  var brand = arguments.length > 2 ? arguments[2] : undefined;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    brand: brand,
    theme: theme,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, ui);
};
export var PropsTestComponent = function PropsTestComponent(props) {
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "props",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 10
    }
  }, JSON.stringify(props));
};
export var getComponentProps = function getComponentProps(getByTestId) {
  var propsString = getByTestId('props').innerHTML;
  return propsString ? JSON.parse(propsString) : {};
};
export var jestMatchers = {
  /**
   * @example
   * expect([1, 2, 3]).toBeSubsetOf([1, 2, 3]); // PASS
   * expect([1, 2, 3]).toBeSubsetOf([1, 2, 3, 4]); // PASS
   *
   * expect([1, 2, 3, 4]).toBeSubsetOf([1, 2, 3]); // FAIL
   */
  toBeSubsetOf: function toBeSubsetOf(_received, _collection) {
    var _this2 = this;
    var received = _received.sort(),
      collection = _collection.sort();
    var unExpectedModules = received.filter(function (m) {
      return !collection.includes(m);
    });
    var numUnExpectedModules = unExpectedModules.length;
    var pass = numUnExpectedModules <= 0;
    var message = pass ? function () {
      return _this2.utils.matcherHint('.not.toOnlyContain') + '\n\n' + "Expected collection contain additional values:\n" + "  ".concat(_this2.utils.printExpected(collection), "\n") + "Received:\n" + "  ".concat(_this2.utils.printReceived(received));
    } : function () {
      var diffString = diff(collection.sort(), received.sort(), {
        expand: _this2.expand
      });
      return _this2.utils.matcherHint('.toOnlyContain') + '\n\n' + "Expected collection only contain:\n" + "  ".concat(_this2.utils.printExpected(collection), "\n") + "Received:\n" + "  ".concat(_this2.utils.printReceived(received)) + (diffString ? "\n\nDifference:\n\n".concat(diffString) : '');
    };
    return {
      actual: received,
      message: message,
      pass: pass
    };
  }
};